module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/line-red-long.9a502548.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/FortBattleSeries/images/line-red-long.png
// module id = 3226
// module chunks = 11